'use client';
import { createContext } from 'react';
import { useNonNullishContext } from '../../hooks/use-non-nullish-context.js';

const AlertBoxContext = createContext(void 0);
function useAlertBoxContext() {
    return useNonNullishContext(AlertBoxContext);
}

export { AlertBoxContext, useAlertBoxContext };
